import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

export const ServiceBanner = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/me/service").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s || !["expired", "expiring"].includes(s.status)) return null;
  const expired = s.status === "expired";
  const end = new Date(`${s.end_date}T12:00:00`).toLocaleDateString("es-ES", { day: "numeric", month: "long", year: "numeric" });
  return (
    <div data-testid="service-banner" style={{ background: expired ? "rgba(248,113,113,0.1)" : "rgba(250,204,21,0.08)", border: `1px solid ${expired ? "rgba(248,113,113,0.4)" : "rgba(250,204,21,0.35)"}`, color: expired ? "#fecaca" : "#fde68a", padding: "10px 14px", fontSize: 13, marginBottom: 16 }}>
      {expired ? `Tu servicio finalizó el ${end}. El área está en modo solo lectura.` : `Tu servicio finaliza el ${end} (${s.days_left === 0 ? "hoy" : `en ${s.days_left} días`}).`}{" "}
      <Link to="/app/mi-area" style={{ color: "inherit", textDecoration: "underline" }}>Ver detalles</Link>
    </div>
  );
};
